export default __webpack_public_path__ + "static/media/20.03d0bdee.jpg";